"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CustomLink: ()=>CustomLink
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const InlineCitationLink_js_namespaceObject = require("../MetadataMarker/InlineCitationLink.js");
const InlineLocationLink_js_namespaceObject = require("../MetadataMarker/InlineLocationLink.js");
const external_locationMetadataLinkClickHandler_js_namespaceObject = require("./locationMetadataLinkClickHandler.js");
const useChatUIContext_js_namespaceObject = require("../../hooks/useChatUIContext.js");
const external_MetadataManager_js_namespaceObject = require("./MetadataManager.js");
const CustomLink = ({ children, href })=>{
    const { setIsMapOpened } = (0, useChatUIContext_js_namespaceObject.useChatUIContext)();
    const url = new URL(href);
    const type = url.searchParams.get('type');
    const webPageName = url.searchParams.get('webPageName');
    const citationNumber = url.searchParams.get('citationNumber');
    if ('CITATION' === type && webPageName && citationNumber) {
        const metadata = {
            name: '',
            type,
            citationNumber
        };
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(InlineCitationLink_js_namespaceObject.InlineCitationLink, {
            metadata: metadata
        });
    }
    const name = url.searchParams.get('name');
    const lat = url.searchParams.get('lat');
    const lng = url.searchParams.get('lng');
    const hotelId = url.searchParams.get('hotelId');
    if (type && name && lat && lng) {
        const metadata = {
            name,
            type,
            lat: Number(lat),
            lng: Number(lng),
            hotelId
        };
        external_MetadataManager_js_namespaceObject.inlineMetadataManager.appendNewPinToList({
            singlePin: metadata,
            listOfPins: []
        });
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(InlineLocationLink_js_namespaceObject.InlineLocationLink, {
            metadata: metadata,
            pinsInCurrentLine: [
                metadata
            ],
            handleMapButtonClick: ()=>{
                (0, external_locationMetadataLinkClickHandler_js_namespaceObject.locationMetadataLinkClickHandler)({
                    pinsInCurrentLine: [
                        metadata
                    ],
                    targetPin: metadata,
                    setIsMapOpened
                });
            }
        });
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Link, {
        href: href,
        target: "_blank",
        children: children
    });
};
exports.CustomLink = __webpack_exports__.CustomLink;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CustomLink"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
